<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="logsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_LOGS',
        formComponent: {
          view: { type: 'component', componentName: 'Logs-view', value: 'queryLogsDetailData' },
          add: { type: 'component', componentName: 'Logs-edit', value: 'resetLogsDetailData' },
          edit: { type: 'component', componentName: 'Logs-edit', value: 'queryLogsDetailData' },
          list: { type: 'default', value: '/modules/logs/logsModuleList' },
          delete: { type: 'default', value: '/modules/logs/lopperDelete' }
        },
        formInputsData: [
          { name: '搜索', key: 'userName', value: '', type: 'text' },
          { name: '创建时间', key: 'updateTimeRange', value: [], type: 'datetime' }
          // { name: '操作名', key: 'operate', value: '', type: 'text' },
        ],
        formButtonsData: [{ name: '清空', key: 'DELETEALL', action: 'DELETEALL', hidden: false, permission: 'CLEAR' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          // { name: '操作', key: 'operate', type: 'text' },
          { name: '用户名', key: 'userName', type: 'text' },
          { name: 'IP', key: 'ip', type: 'text' },
          { name: '内容', key: 'content', type: 'text' },
          { name: '创建时间', key: 'createTime', sortable: 'custom', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', hidden: false },
          { name: '编辑', key: 'EDIT', action: 'EDIT', hidden: false },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, buttonHidden: true, index: true }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'DELETEALL') {
          this.$wtUtil.deleteConfirm(this, '确认清空？').then(() => {
            request({
              url: '/modules/logs/lopperClear',
              method: 'post'
            }).then(res => {
              if (res.code === '0') {
                this.$message({ message: '清空成功', type: 'success' })
                this.$refs.logsTableRef.requestList()
              }
            })
          })
        }
      }
    }
  }
}
</script>
